/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';

const systemReminderGirdHead = [
  {
    headerName: 'Rebate Program/ Check Payee',
    field: 'reminderShortDescr',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_250,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Reminder Type',
    field: 'reminderTypeCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Description',
    field: 'reminderName',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_350,
    columnSpan: 3,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'DescriptionCellRender',
    cellClass: 'frr-ellipsis-text',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];
export default systemReminderGirdHead;
